import React from 'react';
import { Landmark, Building2, Hotel } from 'lucide-react';
import { Card } from '../ui/card';

/** Safe HTML renderer — only allows <strong> tags, prevents XSS */
const SafeHTML = ({ html }) => {
  if (!html) return null;
  const parts = html.split(/(<strong>.*?<\/strong>)/g);
  return parts.map((part, i) => {
    if (part.startsWith('<strong>') && part.endsWith('</strong>')) {
      const content = part.slice(8, -9);
      return <strong key={`safe-html-strong-${i}-${content.slice(0, 10)}`}>{content}</strong>;
    }
    return <React.Fragment key={`safe-html-text-${i}`}>{part}</React.Fragment>;
  });
};

const WhoForSection = ({ t, language }) => {
  return (
    <section id="who-for" className="who-for-section" aria-labelledby="who-for-title">
      <h2 id="who-for-title" className="section-title who-for-title">
        <span className="title-normal">
          {language === 'bg' ? 'За кого е' : language === 'en' ? 'Who is' : language === 'fr' ? 'Pour qui est' : 'F\u00FCr wen ist'}
        </span>
        <span className="title-brand-with-suffix"> UrbanCage<sup className="trademark">{'\u00AE'}</sup></span>
        <span className="title-suffix">{language === 'en' ? ' for' : ''}</span>
      </h2>
      <div className="who-for-grid">
        {/* Column 1: Institutions/Schools */}
        <Card className="who-for-card">
          <div className="card-icon">
            <Landmark size={48} aria-hidden="true" />
          </div>
          <h3>{t.institution}</h3>
          <ul className="feature-list">
            <li><SafeHTML html={t.institutionDesc1} /></li>
            <li><SafeHTML html={t.institutionDesc2} /></li>
            <li><SafeHTML html={t.institutionDesc3} /></li>
          </ul>
        </Card>

        {/* Column 2: Architects & Construction */}
        <Card className="who-for-card">
          <div className="card-icon">
            <Building2 size={48} aria-hidden="true" />
          </div>
          <h3>{t.architect}</h3>
          <ul className="feature-list">
            <li><SafeHTML html={t.architectDesc1} /></li>
            <li><SafeHTML html={t.architectDesc2} /></li>
            <li><SafeHTML html={t.architectDesc3} /></li>
          </ul>
        </Card>

        {/* Column 3: Hotels & Resorts */}
        <Card className="who-for-card">
          <div className="card-icon">
            <Hotel size={48} aria-hidden="true" />
          </div>
          <h3>{t.hotel}</h3>
          <ul className="feature-list">
            <li><SafeHTML html={t.hotelDesc1} /></li>
            <li><SafeHTML html={t.hotelDesc2} /></li>
            <li><SafeHTML html={t.hotelDesc3} /></li>
          </ul>
        </Card>
      </div>
    </section>
  );
};

export default React.memo(WhoForSection);
